import { Table, TableBody, TableCell, TableHead, TableRow, Box, Typography } from "@mui/material";
import dayjs from "dayjs";

const HistoryTable = ({ data }) => {
	if (!data || data.length === 0)
		return (
			<Typography textAlign="center" p={2} color="gray">
				No updates found
			</Typography>
		);

	const sorted = [...data].sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt));

	return (
		<Box
			sx={{
				border: "1px solid #ddd",
				borderRadius: 2,
				overflow: "hidden",
				overflowY: "auto",
			}}>
			<Table
				size="small"
				stickyHeader
				sx={{
					tableLayout: "fixed",
					"& th, & td": {
						borderRight: "1px solid #eee",
						wordBreak: "break-word",
						whiteSpace: "normal",
						py: 1,
						px: 1,
					},
				}}>
				<TableHead>
					<TableRow>
						<TableCell sx={{ width: "22%" }}>
							<b>Date</b>
						</TableCell>
						<TableCell sx={{ width: "28%" }}>
							<b>Field</b>
						</TableCell>
						<TableCell sx={{ width: "30%" }}>
							<b>Value</b>
						</TableCell>
						<TableCell sx={{ width: "20%" }}>
							<b>Updated By</b>
						</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					{sorted.map((row, i) => {
						const keys = Object.keys(row).filter(
							(k) => !["id", "i_code", "createdAt", "updatedAt", "last_updated_by"].includes(k) && row[k]
						);

						return keys.map((k, index) => (
							<TableRow key={`${i}-${index}`}>
								{/* DATE CELL */}
								{index === 0 ? (
									<TableCell rowSpan={keys.length} sx={{ fontWeight: 600 }}>
										{dayjs(row.updatedAt || row.createdAt).format("DD MMM YYYY • hh:mm A")}
									</TableCell>
								) : null}

								{/* FIELD */}
								<TableCell>{String(k).replace(/_/g, " ").toUpperCase()}</TableCell>

								{/* VALUE (handles overflow properly now) */}
								<TableCell>
									{typeof row[k] === "string" && row[k].includes("T") ? dayjs(row[k]).format("DD/MM/YYYY") : row[k]}
								</TableCell>

								{/* UPDATED BY */}
								{index === 0 ? (
									<TableCell rowSpan={keys.length} sx={{ fontSize: 13 }}>
										{row.last_updated_by}
									</TableCell>
								) : null}
							</TableRow>
						));
					})}
				</TableBody>
			</Table>
		</Box>
	);
};

export default HistoryTable;
